import type { Installments } from '../../../../modules/privateOffer/reducer'
import { DetailInfo, DetailRow } from '@labrav/common'
import { useTimeZone } from '../../../../common/utils/hooks/useTimeZone'
import { DateTime } from 'luxon'
import { standardLabraDateFormat } from '@labrav/common'
import { isNonEmptyNumber } from '@labrav/common'
import { get } from 'lodash'
import { useStyles } from './ChannelOfferInstallmentsView.styles'
import { numberFormat } from '@labrav/common'

type CppoInstallmentProps = {
  installments?: Installments[]
  isvFlexiblePriceMarginPercentage?: number
  currencySymbol?: string
}

export const ChannelOfferInstallmentsView = ({
  installments,
  isvFlexiblePriceMarginPercentage,
  currencySymbol,
}: CppoInstallmentProps) => {
  const { classes } = useStyles()
  const { timeZone } = useTimeZone()

  const gridSize = isvFlexiblePriceMarginPercentage ? 4 : 6

  const installmentList = (installments || []).map((installment, index) => {
    const dateValue = DateTime.fromISO(installment?.paymentDate, {
      zone: timeZone,
    }).toFormat(standardLabraDateFormat)
    const installmentAmount = get(installment, 'amount')
    const isvInstallmentAmount = get(installment, 'otherAmount')

    return (
      <DetailRow
        borderBottom={index + 1 !== (installments || [] || []).length}
        children={
          <>
            <DetailInfo
              value={dateValue}
              keyName="dateValue"
              gridSize={gridSize}
              varient="small"
            />
            {isvFlexiblePriceMarginPercentage && (
              <DetailInfo
                keyName="isvAmount"
                gridSize={gridSize}
                varient="small"
                value={
                  isNonEmptyNumber(isvInstallmentAmount as number) ? (
                    <>
                      <div className={classes.amount}>
                        <span className={classes.currency}>
                          {currencySymbol}
                        </span>{' '}
                        {numberFormat(isvInstallmentAmount as number)}
                      </div>
                    </>
                  ) : (
                    '-'
                  )
                }
              />
            )}
            <DetailInfo
              keyName="cppoInstallmentAmount"
              gridSize={gridSize}
              varient="small"
              value={
                isNonEmptyNumber(installmentAmount as number) ? (
                  <>
                    <div className={classes.amount}>
                      <span className={classes.currency}>{currencySymbol}</span>{' '}
                      {numberFormat(installmentAmount as number)}
                    </div>
                  </>
                ) : (
                  '-'
                )
              }
            />
          </>
        }
      />
    )
  })

  return (
    <div className={classes.root} data-testid={'installments-view'}>
      <DetailRow
        borderBottom
        children={
          <>
            <DetailInfo
              varient="small"
              gridSize={gridSize}
              title="Invoice date"
            />
            {isvFlexiblePriceMarginPercentage && (
              <DetailInfo
                varient="small"
                gridSize={gridSize}
                title={<div className={classes.titleRight}>Payment to ISV</div>}
              />
            )}
            <DetailInfo
              varient="small"
              gridSize={gridSize}
              title={
                <div className={classes.titleRight}>Payment from buyer</div>
              }
            />
          </>
        }
      />
      {installmentList}
    </div>
  )
}
